document.getElementById('freight-calculator-form').addEventListener('submit', async function (e) {
    e.preventDefault();

    const cep = document.getElementById('freight-calculator-cep').value;

    // Obtendo o valor da nota fiscal e limpando a string
    let priceText = (document.querySelector('.price-item--sale') || document.querySelector('.price-item--regular')).textContent.trim();
    priceText = priceText.replace(/[^\d,.-]/g, ''); // Remove tudo exceto dígitos, vírgulas, pontos e sinais de menos
    priceText = priceText.replace(',', '.'); // Substitui a vírgula por ponto para que parseFloat funcione corretamente
    const shipmentInvoiceValue = parseFloat(priceText);

    const loadingDiv = document.getElementById('freight-calculator-loading');
    const resultsDiv = document.getElementById('freight-calculator-results');

    // Mostrar mensagem de carregamento
    loadingDiv.style.display = 'block';
    resultsDiv.style.display = 'none';

    try {
        const response = await fetch('https://freight-calculator-andres-projects-31b8c63f.vercel.app/api/get-freight', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                SellerCEP: '22775024', // CEP do vendedor fixo
                RecipientCEP: cep,
                ShipmentInvoiceValue: shipmentInvoiceValue, // Valor da nota fiscal baseado no conteúdo da div
                ShippingItemArray: [
                    {
                        Height: 4,
                        Length: 16,
                        Quantity: 1,
                        Weight: 0.1,
                        Width: 24,
                        SKU: 'IDW_54626',
                        Category: 'Running'
                    }
                ],
                RecipientCountry: 'BR'
            })
        });

        const data = await response.json();

        // Ocultar mensagem de carregamento
        loadingDiv.style.display = 'none';

        if (data.ShippingSevicesArray) {
            resultsDiv.innerHTML = ''; // Limpar resultados anteriores

            data.ShippingSevicesArray.forEach(service => {
                const resultItem = document.createElement('div');
                resultItem.classList.add('freight-calculator-result-item');

                const shippingPrice = parseFloat(service.ShippingPrice);
                const priceText = shippingPrice === 0 ? 'Grátis' : `R$ ${shippingPrice.toFixed(2)}`;

                const description = document.createElement('div');
                description.innerHTML = `${service.ServiceDescription} (${service.DeliveryTime} dias úteis): <span>${priceText}</span>`;
                resultItem.appendChild(description);

                resultsDiv.appendChild(resultItem);
            });

            const info = document.createElement('div');
            info.classList.add('frete-extrainfo');
            info.innerHTML = '🚀 Esse prazo já inclui o nosso tempo de produção.';
            resultsDiv.appendChild(info);

            resultsDiv.style.display = 'block';
        } else {
            throw new Error('No shipping services available');
        }
    } catch (error) {
        loadingDiv.style.display = 'none';
        alert('Erro ao obter cotações de frete. Por favor, tente novamente.');
    }
});
